<div class="p-grid">
  <!--Rol-->
  <div class="p-col-12 p-field">
    <label for="name">Nombre</label><br>
    <input name="name" type="text" pInputText [(ngModel)]="role.name">
  </div>

  <div class="p-col-12">
    <p-checkbox name="checked_all" [(ngModel)]="checked_all" (onChange)="check_all()" [binary]="true"></p-checkbox>
    <label for="checked_all" class="p-ml-2">Seleccionar todos</label>
  </div>
  <!--Permisos-->
  <div class="p-col-12">
    <p-accordion>
      <div *ngFor="let permissionGroup of permissionsGroup">
        <p-accordionTab *ngIf="getPermissions(permissionGroup).length > 0">
          <ng-template pTemplate="header">{{permissionGroup.name}}</ng-template>
          <ng-template pTemplate="content">
            <div class="p-grid">
              <div *ngFor="let permission of getPermissions(permissionGroup)" class="p-col-4">
                <label>
                  <p-checkbox name="groupname" value="{{permission.id}}"
                              [(ngModel)]="selectedPermissions" (onChange)="updateChecked()"></p-checkbox>
                  {{permission.name}}
                </label>
              </div>
            </div>
          </ng-template>
        </p-accordionTab>
      </div>
    </p-accordion>
  </div>
  <!--div *ngFor="let permissionGroup of permissionsGroup" class="p-col-3">
      <p-card [header]="permissionGroup.name">
          <div *ngFor="let permission of getPermissions(permissionGroup)" class="p-field p-col-12">
              <label>
                  <p-checkbox name="groupname" value="{{permission.id}}" [(ngModel)]="selectedPermissions"></p-checkbox>
                  {{permission.name}}
              </label>
          </div>
      </p-card>
  </div-->
  <!--Opciones-->
  <div class="p-col-12">
    <button pButton class="p-button-danger" *ngIf="role.id>0" (click)="delete()" icon="pi pi-trash"
            label="Eliminar"></button>
    <button pButton class="p-ml-2" style="float: right;" (click)="isDuplied()" icon="pi pi-check"
            label="Guardar"></button>
    <button pButton class="p-button-secondary p-button-text" style="float: right;" (click)="cancel()"
            icon="pi pi-times" label="Cancelar"></button>
  </div>
</div>
<p-confirmDialog></p-confirmDialog>
